import { DESIGN_TOKENS } from 'constants/color.constants'
import { OrderStatusType } from 'types/order.types'

export const TEXT_COLORS_MAP: Record<OrderStatusType, string> = {
    quoting: DESIGN_TOKENS.pill.text.orange,
    procuring: DESIGN_TOKENS.pill.text.cyan,
    scheduled: DESIGN_TOKENS.pill.text.blue,
    inTransit: DESIGN_TOKENS.pill.text.purple,
    delivered: DESIGN_TOKENS.pill.text.green,
    cancelled: DESIGN_TOKENS.pill.text.red,
    onHold: DESIGN_TOKENS.pill.text.yellow,
    quoteLost: DESIGN_TOKENS.pill.text.pink,
}

export const BORDER_COLORS_MAP: Record<OrderStatusType, string> = {
    quoting: DESIGN_TOKENS.pill.border.orange,
    procuring: DESIGN_TOKENS.pill.border.cyan,
    scheduled: DESIGN_TOKENS.pill.border.blue,
    inTransit: DESIGN_TOKENS.pill.border.purple,
    delivered: DESIGN_TOKENS.pill.border.green,
    cancelled: DESIGN_TOKENS.pill.border.red,
    onHold: DESIGN_TOKENS.pill.border.yellow,
    quoteLost: DESIGN_TOKENS.pill.border.pink,
}

export const BACKGROUND_COLORS_MAP: Record<OrderStatusType, string> = {
    quoting: DESIGN_TOKENS.pill.background.orange,
    procuring: DESIGN_TOKENS.pill.background.cyan,
    scheduled: DESIGN_TOKENS.pill.background.blue,
    inTransit: DESIGN_TOKENS.pill.background.purple,
    delivered: DESIGN_TOKENS.pill.background.green,
    cancelled: DESIGN_TOKENS.pill.background.red,
    onHold: DESIGN_TOKENS.pill.background.yellow,
    quoteLost: DESIGN_TOKENS.pill.background.pink,
}
